import { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import "./Single.scss";
import Navbar from "../../../shared/components/navbar/Navbar";
import Sidebar from "../../../shared/components/sidebar/Sidebar";

import { useHttpClient } from "../../../shared/hooks/http-hook";
import { AuthContext } from "../../../shared/context/auth-context";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

import toast from "react-hot-toast";
import { useLoading } from "../../../shared/context/LoadingContext";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import moment from "moment";

import IconButton from "@mui/material/IconButton";
import { Tabs, Tab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import { criarSemanalPadrao } from "../../../shared/util/disponibilidade";

function SingleUser() {
  const [userData, setUserData] = useState();
  /* O interruptor do aviso de documentos. Sincroniza com o utilizador quando
     ele chega — ver o `useEffect` mais abaixo. */
  const [avisarDocumentos, setAvisarDocumentos] = useState(false);
  const antigaPalavraPassRef = useRef(null);
  const novaPalavraPassRef = useRef(null);

  const nomeRef = useRef(null);
  const emailRef = useRef(null);
  const duracaoAgendamentoRef = useRef(null);
  const [horarioAtendimento, setHorarioAtendimento] = useState({
    start: moment().startOf("day").add(8, "hours"),
    end: moment().startOf("day").add(20, "hours"),
  });

  const [showExcecaoForm, setShowExcecaoForm] = useState(false);
  const [novaExcecao, setNovaExcecao] = useState({
    data: moment().startOf("day"),
    periodos: [],
    motivo: "",
    bloqueado: false,
  });
  const [editingExcecaoIndex, setEditingExcecaoIndex] = useState(null);

  // Novos estados para disponibilidade
  const [diaSelecionado, setDiaSelecionado] = useState(1); // 1 = Segunda
  const [disponibilidadeSemanal, setDisponibilidadeSemanal] =
    useState(criarSemanalPadrao());

  const [diasDisponiveis, setDiasDisponiveis] = useState([0, 1, 2, 3, 4, 5, 6]);
  const { sendRequest } = useHttpClient();
  const { startLoading, stopLoading } = useLoading();

  const userId = useParams().userId;
  const auth = useContext(AuthContext);
  const [excecoes, setExcecoes] = useState([]);
  const [periodosEspeciais, setPeriodosEspeciais] = useState([]);
  const [showPeriodoEspecialForm, setShowPeriodoEspecialForm] = useState(false);
  const [novoPeriodoEspecial, setNovoPeriodoEspecial] = useState({
    nome: "",
    dataInicio: moment(),
    dataFim: moment().add(7, "days"),
    horarioPadrao: criarSemanalPadrao(),
  });
  const [editingPeriodoEspecial, setEditingPeriodoEspecial] = useState(null);
  const [diaSelecionadoPeriodoEspecial, setDiaSelecionadoPeriodoEspecial] =
    useState(1);

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [assinatura, setAssinatura] = useState({
    imagem: null,
    ativa: false,
    autorizacoes: {
      orcamentos: false,
      prescricoes: false,
      atestados: false,
      impressos: false,
    },
  });
  const [previewAssinatura, setPreviewAssinatura] = useState(null);
  const assinaturaInputRef = useRef(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/${userId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        if (responseData.user.horarioAtendimento) {
          setHorarioAtendimento({
            start: moment(responseData.user.horarioAtendimento.start, "HH:mm"),
            end: moment(responseData.user.horarioAtendimento.end, "HH:mm"),
          });
        }

        if (responseData.user.disponibilidade) {
          const dispSemanal = {};

          if (responseData.user.disponibilidade.horarioPadrao) {
            const horarioPadraoObj =
              responseData.user.disponibilidade.horarioPadrao;

            for (let dia = 0; dia <= 6; dia++) {
              const diaStr = dia.toString();
              const periodos = horarioPadraoObj[diaStr]; // ACESSO DIRETO, não .get()

              if (periodos && Array.isArray(periodos) && periodos.length > 0) {
                dispSemanal[dia] = periodos.map((p) => ({
                  start: moment(p.start, "HH:mm:ss"), // Importante: formato HH:mm:ss
                  end: moment(p.end, "HH:mm:ss"),
                }));
              } else {
                dispSemanal[dia] = [];
              }
            }

            setDisponibilidadeSemanal(dispSemanal);
          }

          if (responseData.user.disponibilidade.excecoes) {
            setExcecoes(
              responseData.user.disponibilidade.excecoes.map((exc) => ({
                ...exc,
                data: moment.utc(exc.data).startOf("day"),
                periodos: exc.periodos.map((p) => ({
                  start: moment(p.start, "HH:mm:ss"),
                  end: moment(p.end, "HH:mm:ss"),
                })),
              })),
            );
          }
          if (responseData.user.disponibilidade.diasDisponiveis) {
            setDiasDisponiveis(
              responseData.user.disponibilidade.diasDisponiveis,
            );
          }

          if (responseData.user.disponibilidade.periodosEspeciais) {
            setPeriodosEspeciais(
              responseData.user.disponibilidade.periodosEspeciais.map(
                (periodo) => {
                  const horarioPadraoObj = periodo.horarioPadrao;
                  const horarioPadraoConvertido = {};

                  Object.keys(horarioPadraoObj).forEach((dia) => {
                    horarioPadraoConvertido[dia] = horarioPadraoObj[dia].map(
                      (p) => ({
                        start: moment(p.start, "HH:mm:ss"),
                        end: moment(p.end, "HH:mm:ss"),
                      }),
                    );
                  });

                  return {
                    ...periodo,
                    id: periodo._id || crypto.randomUUID(),
                    dataInicio: moment.utc(periodo.dataInicio),
                    dataFim: moment.utc(periodo.dataFim),
                    horarioPadrao: horarioPadraoConvertido,
                  };
                },
              ),
            );
          }
        }

        if (responseData.user.assinatura) {
          setAssinatura({
            imagem: responseData.user.assinatura.imagem || null,
            ativa: responseData.user.assinatura.ativa || false,
            autorizacoes: {
              orcamentos:
                responseData.user.assinatura.autorizacoes?.orcamentos || false,
              prescricoes:
                responseData.user.assinatura.autorizacoes?.prescricoes || false,
              atestados:
                responseData.user.assinatura.autorizacoes?.atestados || false,
              impressos:
                responseData.user.assinatura.autorizacoes?.impressos || false,
            },
          });
          if (responseData.user.assinatura.imagem) {
            setPreviewAssinatura(
              `${process.env.REACT_APP_BACKEND_LINK}/${responseData.user.assinatura.imagem}`,
            );
          }
        }

        setUserData(responseData.user);
        setAvisarDocumentos(!!responseData.user.avisarSecretariaDocumentos);
      } catch (err) {}
    };
    fetchUser();
  }, [auth.token, sendRequest, userId]);

  const alterarPalavraPassHandler = async () => {
    startLoading();
    try {
      let mensagemErro = "";

      if (
        novaPalavraPassRef.current.value === antigaPalavraPassRef.current.value
      ) {
        mensagemErro = "A palavra passe antiga e a atual não podem ser iguais";
      } else if (
        novaPalavraPassRef.current.value.trim() === "" ||
        antigaPalavraPassRef.current.value.trim() === ""
      ) {
        mensagemErro = "Os campos não podem ser vazios";
      } else if (novaPalavraPassRef.current.value.length < 7) {
        mensagemErro = "A palavra passe tem que ter pelo menos 7 caracters";
      }

      if (!mensagemErro) {
        try {
          const formData = new FormData();
          formData.append("newPass", novaPalavraPassRef.current.value);
          formData.append("oldPass", antigaPalavraPassRef.current.value);

          const responseData = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/atualizarpalavrapasse/${userId}`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );

          if (responseData.type === "erro") {
            toast.error(responseData.msg);
          } else {
            toast.success(responseData.msg);
          }
        } catch (err) {
          console.err("err", err);
        }
      } else {
        toast.error(mensagemErro);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const guardarDadosUtilizadorHandler = async () => {
    startLoading();
    try {
      let mensagemErro = "";

      const reEmail = /^[\w.-]+@[\w.-]+\.[a-z]{2,4}$/;
      // const reNome = /^[a-zA-Z\s-']+$/;

      if (
        nomeRef.current.value.trim() === "" ||
        emailRef.current.value.trim() === ""
      ) {
        mensagemErro = "Os campos não podem estar vazios";
      } else if (!reEmail.test(emailRef.current.value)) {
        mensagemErro = "email com formato incorreto";
      }
      // else if (!reNome.test(nomeRef.current.value)) {
      //   mensagemErro = "nome com formato incorreto";
      // }

      if (!mensagemErro) {
        try {
          const formData = new FormData();
          formData.append("email", emailRef.current.value);
          formData.append("name", nomeRef.current.value);

          await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/${userId}`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
          toast.success("Dados atualizados com sucesso");
        } catch (err) {
          console.error("err", err);
        }
      } else {
        toast.error(mensagemErro);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  /* ── Avisar a secretária dos documentos que este utilizador cria ──────────
   *
   * Grava de imediato ao mudar o interruptor, sem botão de confirmar: é um
   * valor só, e um botão «Atualizar» ao lado de uma caixa já marcada deixa a
   * dúvida de se ficou gravado ou não.
   *
   * Em caso de erro volta atrás no ecrã. Um interruptor que fica ligado depois
   * de a gravação falhar é pior do que um erro visível: a pessoa sai convencida
   * de que a clínica vai ser avisada, e não vai.
   * ----------------------------------------------------------------------- */
  const alterarAvisoDocumentosHandler = async (novoValor) => {
    setAvisarDocumentos(novoValor);
    try {
      const formData = new FormData();
      formData.append("avisar", novoValor);
      formData.append("utilizador", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/users/atualizaravisodocumentos/${userId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );
      toast.success(
        novoValor
          ? "A secretária passa a ser avisada dos documentos criados."
          : "A secretária deixa de ser avisada dos documentos criados.",
      );
    } catch (err) {
      setAvisarDocumentos(!novoValor);
      console.error("err", err);
    }
  };

  const alterarDuracaoAgendamentoHandler = async () => {
    const novaDuracao = duracaoAgendamentoRef.current.value;
    if (!novaDuracao) {
      toast.error("Introduza um valor para a nova duração de agendamento.");
    } else {
      startLoading();
      try {
        const formData = new FormData();
        formData.append("duracao", novaDuracao);
        formData.append("utilizador", auth.userId);
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/atualizarduracaoagendamento/${userId}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        toast.success("Duração de agendamento atualizada com sucesso!");
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    }
  };

  const validateHorario = () => {
    let tempErrors = {};

    if (!horarioAtendimento.start.isValid()) {
      tempErrors.start = "Horário de início inválido";
    }

    if (!horarioAtendimento.end.isValid()) {
      tempErrors.end = "Horário de fim inválido";
    }

    if (
      horarioAtendimento.start.isValid() &&
      horarioAtendimento.end.isValid()
    ) {
      if (horarioAtendimento.start.isSameOrAfter(horarioAtendimento.end)) {
        tempErrors.end = "O horário de fim deve ser após o horário de início";
      }
    }
    return Object.keys(tempErrors).length === 0;
  };

  const alterarHorarioAtendimentoHandler = async () => {
    if (!validateHorario()) {
      toast.error("Introduza valores corretos para horários de atendimento.");
    } else {
      startLoading();
      try {
        const formData = new FormData();
        const formattedHorarioAtendimento = JSON.stringify({
          start: moment(horarioAtendimento.start).format("HH:mm:ss"),
          end: moment(horarioAtendimento.end).format("HH:mm:ss"),
        });

        formData.append("horarioAtendimento", formattedHorarioAtendimento);
        formData.append("utilizador", auth.userId);
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/atualizarhorarioatendimento/${userId}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        toast.success("Horário de atendimento atualizado com sucesso!");
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    }
  };

  const handleAssinaturaFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPreviewAssinatura(URL.createObjectURL(file));
  };

  const guardarAssinaturaHandler = async () => {
    startLoading();
    try {
      const formData = new FormData();

      if (assinaturaInputRef.current?.files[0]) {
        // O originalname precisa ter o formato que o backend espera
        const file = assinaturaInputRef.current.files[0];
        formData.append("assinatura", file);
      }

      formData.append("ativa", assinatura.ativa);
      formData.append("autorizacoes", JSON.stringify(assinatura.autorizacoes));

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/users/atualizarassinatura/${userId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      toast.success("Assinatura atualizada com sucesso!");
    } catch (err) {
      console.error("err", err);
      toast.error("Erro ao atualizar assinatura");
    } finally {
      stopLoading();
    }
  };

  const handleStartChange = (newValue) => {
    setHorarioAtendimento((prev) => ({
      ...prev,
      start: moment(newValue),
    }));
  };

  const handleEndChange = (newValue) => {
    setHorarioAtendimento((prev) => ({
      ...prev,
      end: moment(newValue),
    }));
  };

  // Funções para manipular disponibilidade semanal
  const adicionarPeriodo = () => {
    setDisponibilidadeSemanal((prev) => ({
      ...prev,
      [diaSelecionado]: [
        ...prev[diaSelecionado],
        {
          start: moment().startOf("day").add(8, "hours"),
          end: moment().startOf("day").add(12, "hours"),
        },
      ],
    }));
  };

  const removerPeriodo = (index) => {
    setDisponibilidadeSemanal((prev) => ({
      ...prev,
      [diaSelecionado]: prev[diaSelecionado].filter((_, i) => i !== index),
    }));
  };

  const atualizarPeriodo = (index, campo, valor) => {
    setDisponibilidadeSemanal((prev) => ({
      ...prev,
      [diaSelecionado]: prev[diaSelecionado].map((periodo, i) =>
        i === index ? { ...periodo, [campo]: moment(valor) } : periodo,
      ),
    }));
  };

  const adicionarPeriodoEspecial = async () => {
    try {
      const novoPeriodo = {
        ...novoPeriodoEspecial,
        id: crypto.randomUUID(),
      };

      const novosPeriodosEspeciais = [...periodosEspeciais, novoPeriodo];

      await salvarDisponibilidadeAtual({
        periodosEspeciais: novosPeriodosEspeciais,
      });

      setPeriodosEspeciais(novosPeriodosEspeciais);
      setShowPeriodoEspecialForm(false);
      setNovoPeriodoEspecial({
        nome: "",
        dataInicio: moment(),
        dataFim: moment().add(7, "days"),
        horarioPadrao: criarSemanalPadrao(),
      });
      toast.success("Período especial criado com sucesso!");
    } catch (err) {
      toast.error("Erro ao criar período especial");
      console.error(err);
    }
  };

  const removerPeriodoEspecial = async (id) => {
    try {
      const novosPeriodosEspeciais = periodosEspeciais.filter(
        (p) => p.id !== id,
      );
      await salvarDisponibilidadeAtual({
        periodosEspeciais: novosPeriodosEspeciais,
      });
      setPeriodosEspeciais(novosPeriodosEspeciais);
      toast.success("Período especial removido com sucesso!");
    } catch (err) {
      toast.error("Erro ao remover período especial");
      console.error(err);
    }
  };

  const editarPeriodoEspecial = (periodo) => {
    setEditingPeriodoEspecial(periodo);
    setDiaSelecionadoPeriodoEspecial(1); // Começa na segunda
  };

  const fecharEdicaoPeriodoEspecial = () => {
    setEditingPeriodoEspecial(null);
  };

  const adicionarPeriodoNoPeriodoEspecial = () => {
    if (!editingPeriodoEspecial) return;

    const dia = diaSelecionadoPeriodoEspecial;
    const periodoAtualizado = {
      ...editingPeriodoEspecial,
      horarioPadrao: {
        ...editingPeriodoEspecial.horarioPadrao,
        [dia]: [
          ...(editingPeriodoEspecial.horarioPadrao[dia] || []),
          {
            start: moment().startOf("day").add(8, "hours"),
            end: moment().startOf("day").add(12, "hours"),
          },
        ],
      },
    };

    setPeriodosEspeciais((prev) =>
      prev.map((p) =>
        p.id === editingPeriodoEspecial.id ? periodoAtualizado : p,
      ),
    );
    setEditingPeriodoEspecial(periodoAtualizado);
  };

  const removerPeriodoNoPeriodoEspecial = (diaIndex, periodoIndex) => {
    if (!editingPeriodoEspecial) return;

    const periodoAtualizado = {
      ...editingPeriodoEspecial,
      horarioPadrao: {
        ...editingPeriodoEspecial.horarioPadrao,
        [diaIndex]: editingPeriodoEspecial.horarioPadrao[diaIndex].filter(
          (_, i) => i !== periodoIndex,
        ),
      },
    };

    setPeriodosEspeciais((prev) =>
      prev.map((p) =>
        p.id === editingPeriodoEspecial.id ? periodoAtualizado : p,
      ),
    );
    setEditingPeriodoEspecial(periodoAtualizado);
  };

  const atualizarPeriodoNoPeriodoEspecial = (
    diaIndex,
    periodoIndex,
    campo,
    valor,
  ) => {
    if (!editingPeriodoEspecial) return;

    const periodosAtualizados = [
      ...editingPeriodoEspecial.horarioPadrao[diaIndex],
    ];
    periodosAtualizados[periodoIndex] = {
      ...periodosAtualizados[periodoIndex],
      [campo]: moment(valor),
    };

    const periodoAtualizado = {
      ...editingPeriodoEspecial,
      horarioPadrao: {
        ...editingPeriodoEspecial.horarioPadrao,
        [diaIndex]: periodosAtualizados,
      },
    };

    setPeriodosEspeciais((prev) =>
      prev.map((p) =>
        p.id === editingPeriodoEspecial.id ? periodoAtualizado : p,
      ),
    );
    setEditingPeriodoEspecial(periodoAtualizado);
  };

  const salvarPeriodoEspecial = async () => {
    // Validar sobreposições em cada dia do período especial
    for (const dia of Object.keys(editingPeriodoEspecial.horarioPadrao)) {
      const periodos = editingPeriodoEspecial.horarioPadrao[dia];
      if (periodos.length > 1 && !validarPeriodosSemSobreposicao(periodos)) {
        toast.error(
          `Sobreposição de horários em ${
            diasSemana.find((d) => d.value === parseInt(dia))?.label
          } do período especial`,
        );
        return;
      }
    }

    try {
      await salvarDisponibilidadeAtual();
      fecharEdicaoPeriodoEspecial();
      toast.success("Período especial atualizado com sucesso!");
    } catch (err) {
      toast.error("Erro ao atualizar período especial");
      console.error(err);
    }
  };

  const diasSemana = [
    { value: 1, label: "Segunda" },
    { value: 2, label: "Terça" },
    { value: 3, label: "Quarta" },
    { value: 4, label: "Quinta" },
    { value: 5, label: "Sexta" },
    { value: 6, label: "Sábado" },
    { value: 0, label: "Domingo" },
  ];

  const validarPeriodosSemSobreposicao = (periodos) => {
    const ordenados = [...periodos]
      .filter((p) => p.start.isValid() && p.end.isValid())
      .sort((a, b) => a.start.diff(b.start));

    for (let i = 0; i < ordenados.length - 1; i++) {
      if (ordenados[i].end.isAfter(ordenados[i + 1].start)) {
        return false;
      }
    }
    return true;
  };

  const adicionarExcecao = async () => {
    if (!novaExcecao.bloqueado && novaExcecao.periodos.length === 0) {
      toast.error("Adicione pelo menos um período ou marque como bloqueado");
      return;
    }

    if (
      !novaExcecao.bloqueado &&
      novaExcecao.periodos.length > 1 &&
      !validarPeriodosSemSobreposicao(novaExcecao.periodos)
    ) {
      toast.error("Os períodos da exceção têm sobreposição de horários");
      return;
    }

    try {
      const novasExcecoes =
        editingExcecaoIndex !== null
          ? excecoes.map((exc, idx) =>
              idx === editingExcecaoIndex ? { ...novaExcecao } : exc,
            )
          : [...excecoes, { ...novaExcecao }];

      await salvarDisponibilidadeAtual({ excecoes: novasExcecoes });

      setExcecoes(novasExcecoes);
      setEditingExcecaoIndex(null);
      setShowExcecaoForm(false);
      setNovaExcecao({
        data: moment().startOf("day"),
        periodos: [],
        motivo: "",
        bloqueado: false,
      });
      toast.success(
        editingExcecaoIndex !== null
          ? "Exceção atualizada com sucesso!"
          : "Exceção adicionada com sucesso!",
      );
    } catch (err) {
      toast.error("Erro ao salvar exceção");
      console.error(err);
    }
  };

  const editarExcecao = (index) => {
    setNovaExcecao({ ...excecoes[index] });
    setEditingExcecaoIndex(index);
    setShowExcecaoForm(true);
  };

  const removerExcecao = async (index) => {
    try {
      const novasExcecoes = excecoes.filter((_, i) => i !== index);
      await salvarDisponibilidadeAtual({ excecoes: novasExcecoes });
      setExcecoes(novasExcecoes);
      toast.success("Exceção removida com sucesso!");
    } catch (err) {
      toast.error("Erro ao remover exceção");
      console.error(err);
    }
  };

  const salvarDisponibilidadeCompleta = async (
    userId,
    disponibilidadeAtualizada,
    authToken,
    authUserId,
    sendRequest,
    startLoading,
    stopLoading,
  ) => {
    try {
      startLoading();
      const formData = new FormData();
      formData.append(
        "disponibilidade",
        JSON.stringify(disponibilidadeAtualizada),
      );
      formData.append("utilizador", authUserId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/users/atualizardisponibilidade/${userId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + authToken,
        },
      );

      return true;
    } catch (err) {
      console.error("Erro ao salvar disponibilidade:", err);
      throw err;
    } finally {
      stopLoading();
    }
  };

  const salvarDisponibilidadeAtual = async (overrides = {}) => {
    // Usar os valores mais recentes, com possibilidade de override
    const excecoesFinais = overrides.excecoes ?? excecoes;
    const periodosFinais = overrides.periodosEspeciais ?? periodosEspeciais;
    const semanalFinal =
      overrides.disponibilidadeSemanal ?? disponibilidadeSemanal;

    const horarioPadraoFormatado = {};
    Object.keys(semanalFinal).forEach((dia) => {
      horarioPadraoFormatado[dia] = semanalFinal[dia].map((p) => ({
        start: p.start.format("HH:mm:ss"),
        end: p.end.format("HH:mm:ss"),
      }));
    });

    const excecoesFormatadas = excecoesFinais.map((exc) => ({
      data: moment.utc(exc.data).startOf("day").format("YYYY-MM-DD"),
      periodos: exc.periodos.map((p) => ({
        start: p.start.format("HH:mm:ss"),
        end: p.end.format("HH:mm:ss"),
      })),
      motivo: exc.motivo || "",
      bloqueado: exc.bloqueado || false,
    }));

    const periodosEspeciaisFormatados = periodosFinais.map((periodo) => {
      const horarioPadraoObj = {};
      Object.keys(periodo.horarioPadrao).forEach((dia) => {
        horarioPadraoObj[dia] = periodo.horarioPadrao[dia].map((p) => ({
          start: p.start.format("HH:mm:ss"),
          end: p.end.format("HH:mm:ss"),
        }));
      });
      return {
        nome: periodo.nome,
        dataInicio: periodo.dataInicio.format("YYYY-MM-DD"),
        dataFim: periodo.dataFim.format("YYYY-MM-DD"),
        horarioPadrao: horarioPadraoObj,
      };
    });

    await salvarDisponibilidadeCompleta(
      userId,
      {
        diasDisponiveis: overrides.diasDisponiveis ?? diasDisponiveis,
        horarioPadrao: horarioPadraoFormatado,
        periodosEspeciais: periodosEspeciaisFormatados,
        excecoes: excecoesFormatadas,
      },
      auth.token,
      auth.userId,
      sendRequest,
      startLoading,
      stopLoading,
    );
  };

  return (
    <>
      {userData && (
        <div className="single">
          <Sidebar />
          <div className="singleContainer">
            <Navbar title={auth.nome} icon={PersonOutlineOutlinedIcon} />

            {/* Container info */}
            {userData && (
              <>
                <div style={{ margin: "20px" }}>
                  <div className="mensagem_de_aviso">
                    Estas alterações, só terão efeito, após o reinício da
                    sessão!
                  </div>
                </div>
                <div className="single-user__container">
                  <div className="single-user__container__info__container caixa">
                    <span className="single-user__container__title">
                      Configurações de perfil
                    </span>
                    <span className="single-user__container__subtitle">
                      Esses são detalhes pessoais, visiveis ao público
                    </span>

                    <div className="single-user__container__pass-reset__container__input-container">
                      <span>Nome Completo</span>
                      <input
                        type="text"
                        ref={nomeRef}
                        placeholder={userData.name}
                      />
                    </div>
                    <div className="single-user__container__pass-reset__container__input-container">
                      <span>Email</span>
                      <input
                        type="email"
                        ref={emailRef}
                        placeholder={userData.email}
                      />
                    </div>

                    <button
                      className="single-user__container__btn"
                      onClick={guardarDadosUtilizadorHandler}
                    >
                      Guardar
                    </button>
                  </div>

                  {/* Container Palavra pass */}
                  <div className="single-user__container__pass-reset__container caixa">
                    <span className="single-user__container__title">
                      Atualizar Palavra Passe
                    </span>
                    <span className="single-user__container__subtitle">
                      Introduza a tua palavra passe atual para efetuar a
                      atualização
                    </span>
                    <div className="single-user__container__pass-reset__container__input-container">
                      <span>Palavra Passe Atual</span>
                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type={showOldPassword ? "text" : "password"}
                          ref={antigaPalavraPassRef}
                          style={{ paddingRight: "40px", width: "100%" }}
                        />
                        <IconButton
                          onClick={() => setShowOldPassword((prev) => !prev)}
                          style={{
                            position: "absolute",
                            right: "5px",
                          }}
                          size="small"
                        >
                          {showOldPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </div>
                    </div>
                    <div className="single-user__container__pass-reset__container__input-container">
                      <span>Nova Palavra Passe</span>
                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type={showNewPassword ? "text" : "password"}
                          ref={novaPalavraPassRef}
                          style={{ paddingRight: "40px", width: "100%" }}
                        />
                        <IconButton
                          onClick={() => setShowNewPassword((prev) => !prev)}
                          style={{
                            position: "absolute",
                            right: "5px",
                          }}
                          size="small"
                        >
                          {showNewPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </div>
                    </div>

                    <button
                      className="single-user__container__btn"
                      onClick={alterarPalavraPassHandler}
                    >
                      Atualizar Palavra Passe
                    </button>
                  </div>

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ flexColumn: "1/2" }}>
                      <div className="single-user__container__pass-reset__container__input-container">
                        <span>Duração de agendamento</span>
                        <input
                          type="number"
                          ref={duracaoAgendamentoRef}
                          defaultValue={userData.duracaoConsulta}
                          min={5}
                          max={480}
                        />
                      </div>
                      <button
                        className="single-user__container__btn"
                        onClick={alterarDuracaoAgendamentoHandler}
                      >
                        Atualizar Duração
                      </button>
                    </div>
                  )}

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ flexColumn: "1/2" }}>
                      <div className="single-user__container__pass-reset__container__input-container">
                        <span>Horário de Atendimento</span>

                        <div className="perfil__horarioAtendimento__container">
                          <span>Horário Incial</span>
                          <span>Horário Final</span>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopTimePicker
                              value={horarioAtendimento.start.toDate()}
                              onChange={handleStartChange}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </LocalizationProvider>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopTimePicker
                              value={horarioAtendimento.end.toDate()}
                              onChange={handleEndChange}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                      <button
                        className="single-user__container__btn"
                        onClick={alterarHorarioAtendimentoHandler}
                      >
                        Atualizar Horário
                      </button>
                    </div>
                  )}

                  {/* Avisar a secretária dos documentos criados.
                      Aparece ao PRÓPRIO e a um administrador/gerente.

                      Não olha para o papel do utilizador da ficha, e isso é uma
                      correção: a condição anterior exigia
                      `userData.role.role`, mas o endpoint desta página
                      (`GET /api/users/:uid`) popula `medicos`, `secretarias` e
                      `assistentes` e NÃO popula `role`. O campo chegava como id
                      em bruto, a comparação dava sempre falso, e o bloco não
                      aparecia a ninguém — nem ao administrador na sua própria
                      ficha.

                      O custo de não olhar para o papel é o interruptor aparecer
                      também na ficha de quem não cria documentos, onde não faz
                      efeito. É preferível a não aparecer a quem precisa dele. */}
                  {(String(auth.userId) === String(userId) ||
                    ["Médico/Administrador", "Gerente"].includes(
                      auth.role,
                    )) && (
                      <div className="caixa" style={{ gridColumn: "1 / -1" }}>
                        <div className="single-user__container__pass-reset__container__input-container">
                          <span>Documentos e impressão</span>
                          <label
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 10,
                              cursor: "pointer",
                              marginTop: 8,
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={avisarDocumentos}
                              onChange={(e) =>
                                alterarAvisoDocumentosHandler(e.target.checked)
                              }
                              style={{ marginTop: 3 }}
                            />
                            <span>
                              Avisar a secretária quando crio um documento
                              <br />
                              <small style={{ color: "#607d8b" }}>
                                Para quem não tem impressora no consultório. Cada
                                prescrição, atestado, impresso, requisição ou
                                consentimento criado põe um aviso no sino de quem
                                está ao balcão, com o nome do doente. A primeira
                                pessoa que o abrir resolve-o para as restantes.
                              </small>
                            </span>
                          </label>
                        </div>
                      </div>
                    )}

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ gridColumn: "1 / -1" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <span className="single-user__container__title">
                          Dias de Trabalho
                        </span>
                        <span className="single-user__container__subtitle">
                          Selecione os dias da semana em que está disponível
                          para atendimento
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                          marginTop: "20px",
                        }}
                      >
                        {diasSemana.map((dia) => (
                          <div
                            key={dia.value}
                            onClick={() => {
                              setDiasDisponiveis((prev) =>
                                prev.includes(dia.value)
                                  ? prev.filter((d) => d !== dia.value)
                                  : [...prev, dia.value].sort((a, b) => a - b),
                              );
                            }}
                            style={{
                              padding: "12px 20px",
                              borderRadius: "8px",
                              cursor: "pointer",
                              backgroundColor: diasDisponiveis.includes(
                                dia.value,
                              )
                                ? "#1976D2"
                                : "#f5f5f5",
                              color: diasDisponiveis.includes(dia.value)
                                ? "white"
                                : "#333",
                              border: diasDisponiveis.includes(dia.value)
                                ? "2px solid #1565C0"
                                : "2px solid #e0e0e0",
                              fontWeight: diasDisponiveis.includes(dia.value)
                                ? "600"
                                : "400",
                              transition: "all 0.2s ease",
                              userSelect: "none",
                            }}
                          >
                            {dia.label}
                          </div>
                        ))}
                      </div>

                      <button
                        className="single-user__container__btn"
                        onClick={async () => {
                          try {
                            await salvarDisponibilidadeAtual({
                              diasDisponiveis,
                            });
                            toast.success(
                              "Dias de trabalho atualizados com sucesso!",
                            );
                          } catch (err) {
                            toast.error("Erro ao atualizar dias de trabalho");
                            console.error(err);
                          }
                        }}
                        style={{ marginTop: "20px" }}
                      >
                        Salvar Dias de Trabalho
                      </button>
                    </div>
                  )}

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ gridColumn: "1 / -1" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <span className="single-user__container__title">
                          Disponibilidade Semanal Detalhada
                        </span>

                        <span className="single-user__container__subtitle">
                          Configure horários diferentes para cada dia da semana
                        </span>
                      </div>
                      <Tabs
                        value={diaSelecionado}
                        onChange={(e, newValue) => setDiaSelecionado(newValue)}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
                      >
                        {diasSemana.map((dia) => (
                          <Tab
                            key={dia.value}
                            label={dia.label}
                            value={dia.value}
                          />
                        ))}
                      </Tabs>

                      <div style={{ marginTop: "20px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "15px",
                          }}
                        >
                          <span style={{ fontWeight: "500" }}>
                            Períodos de trabalho -{" "}
                            {
                              diasSemana.find((d) => d.value === diaSelecionado)
                                ?.label
                            }
                          </span>
                          <IconButton
                            color="primary"
                            onClick={adicionarPeriodo}
                            size="small"
                          >
                            <AddIcon />
                          </IconButton>
                        </div>

                        {disponibilidadeSemanal[diaSelecionado]?.length ===
                        0 ? (
                          <div
                            style={{
                              padding: "20px",
                              textAlign: "center",
                              color: "#999",
                              border: "1px dashed #ddd",
                              borderRadius: "4px",
                            }}
                          >
                            Sem períodos configurados para este dia. Clique em +
                            para adicionar.
                          </div>
                        ) : (
                          disponibilidadeSemanal[diaSelecionado]?.map(
                            (periodo, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr auto",
                                  gap: "15px",
                                  alignItems: "center",
                                  padding: "15px",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "4px",
                                  marginBottom: "10px",
                                  backgroundColor: "#fafafa",
                                }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterMoment}
                                >
                                  <DesktopTimePicker
                                    label="Início"
                                    value={periodo.start.toDate()}
                                    onChange={(newValue) =>
                                      atualizarPeriodo(index, "start", newValue)
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} size="small" />
                                    )}
                                  />
                                </LocalizationProvider>

                                <LocalizationProvider
                                  dateAdapter={AdapterMoment}
                                >
                                  <DesktopTimePicker
                                    label="Fim"
                                    value={periodo.end.toDate()}
                                    onChange={(newValue) =>
                                      atualizarPeriodo(index, "end", newValue)
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} size="small" />
                                    )}
                                  />
                                </LocalizationProvider>

                                <IconButton
                                  color="error"
                                  onClick={() => removerPeriodo(index)}
                                  size="small"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </div>
                            ),
                          )
                        )}
                      </div>

                      <button
                        className="single-user__container__btn"
                        onClick={() => salvarDisponibilidadeAtual()}
                        style={{ marginTop: "20px" }}
                      >
                        Salvar Disponibilidade
                      </button>
                    </div>
                  )}

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ gridColumn: "1 / -1" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <span className="single-user__container__title">
                          Períodos Especiais (Horários que Alternam)
                        </span>
                        <span className="single-user__container__subtitle">
                          Configure semanas ou períodos com horários diferentes
                          do padrão
                        </span>
                      </div>

                      {periodosEspeciais.length > 0 && (
                        <div style={{ marginTop: "20px" }}>
                          {periodosEspeciais.map((periodo) => (
                            <div
                              key={periodo.id}
                              style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                padding: "15px",
                                marginBottom: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <strong style={{ fontSize: "16px" }}>
                                    {periodo.nome}
                                  </strong>
                                  <div
                                    style={{
                                      color: "#666",
                                      fontSize: "14px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    📅 {periodo.dataInicio.format("DD/MM/YYYY")}{" "}
                                    até {periodo.dataFim.format("DD/MM/YYYY")}
                                  </div>
                                  <div
                                    style={{
                                      color: "#999",
                                      fontSize: "12px",
                                      marginTop: "3px",
                                    }}
                                  >
                                    {
                                      Object.values(
                                        periodo.horarioPadrao,
                                      ).flat().length
                                    }{" "}
                                    períodos configurados
                                  </div>
                                </div>
                                <div style={{ display: "flex", gap: "8px" }}>
                                  <button
                                    onClick={() =>
                                      editarPeriodoEspecial(periodo)
                                    }
                                    style={{
                                      padding: "6px 12px",
                                      backgroundColor: "#1976D2",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                  >
                                    ⚙️ Configurar Horários
                                  </button>
                                  <IconButton
                                    color="error"
                                    onClick={() =>
                                      removerPeriodoEspecial(periodo.id)
                                    }
                                    size="small"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {!showPeriodoEspecialForm ? (
                        <button
                          className="single-user__container__btn"
                          onClick={() => setShowPeriodoEspecialForm(true)}
                          style={{ marginTop: "15px" }}
                        >
                          + Adicionar Período Especial
                        </button>
                      ) : (
                        <div
                          style={{
                            border: "2px solid #1976D2",
                            borderRadius: "8px",
                            padding: "20px",
                            marginTop: "15px",
                            backgroundColor: "#E3F2FD",
                          }}
                        >
                          <div style={{ marginBottom: "15px" }}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: "5px",
                                fontWeight: "500",
                              }}
                            >
                              Nome do Período
                            </label>
                            <input
                              type="text"
                              placeholder="Ex: Semana de Plantão, Período de Férias Parcial"
                              value={novoPeriodoEspecial.nome}
                              onChange={(e) =>
                                setNovoPeriodoEspecial((prev) => ({
                                  ...prev,
                                  nome: e.target.value,
                                }))
                              }
                              style={{
                                width: "100%",
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DesktopDatePicker
                                label="Data Início"
                                inputFormat="DD-MM-YYYY"
                                value={novoPeriodoEspecial.dataInicio}
                                onChange={(value) =>
                                  setNovoPeriodoEspecial((prev) => ({
                                    ...prev,
                                    dataInicio: value,
                                  }))
                                }
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth />
                                )}
                              />
                            </LocalizationProvider>

                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DesktopDatePicker
                                label="Data Fim"
                                inputFormat="DD-MM-YYYY"
                                value={novoPeriodoEspecial.dataFim}
                                onChange={(value) =>
                                  setNovoPeriodoEspecial((prev) => ({
                                    ...prev,
                                    dataFim: value,
                                  }))
                                }
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth />
                                )}
                              />
                            </LocalizationProvider>
                          </div>

                          <div
                            style={{
                              padding: "15px",
                              backgroundColor: "white",
                              borderRadius: "4px",
                              marginBottom: "15px",
                            }}
                          >
                            <p
                              style={{
                                margin: "0 0 10px 0",
                                fontWeight: "500",
                                color: "#666",
                              }}
                            >
                              ℹ️ Após criar, clique em "Configurar Horários"
                              para definir os períodos de trabalho
                            </p>
                          </div>

                          <div style={{ display: "flex", gap: "10px" }}>
                            <button
                              className="single-user__container__btn"
                              onClick={adicionarPeriodoEspecial}
                              disabled={!novoPeriodoEspecial.nome.trim()}
                              style={{
                                backgroundColor: novoPeriodoEspecial.nome.trim()
                                  ? "#1976D2"
                                  : "#ccc",
                                cursor: novoPeriodoEspecial.nome.trim()
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                            >
                              Adicionar
                            </button>
                            <button
                              className="single-user__container__btn"
                              onClick={() => setShowPeriodoEspecialForm(false)}
                              style={{ backgroundColor: "#757575" }}
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ gridColumn: "1 / -1" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <span className="single-user__container__title">
                          Assinatura Digital
                        </span>
                        <span className="single-user__container__subtitle">
                          A sua assinatura será usada nos documentos que
                          autorizar
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          marginTop: "20px",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* Preview */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "280px",
                              height: "120px",
                              border: "2px dashed #ccc",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#fafafa",
                              overflow: "hidden",
                            }}
                          >
                            {previewAssinatura ? (
                              <img
                                src={previewAssinatura}
                                alt="Assinatura"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            ) : (
                              <span style={{ color: "#999", fontSize: "14px" }}>
                                Sem assinatura carregada
                              </span>
                            )}
                          </div>
                          <input
                            type="file"
                            accept="image/png, image/jpeg, image/jpg"
                            ref={assinaturaInputRef}
                            style={{ display: "none" }}
                            onChange={handleAssinaturaFileChange}
                          />
                          <button
                            className="single-user__container__btn"
                            onClick={() => assinaturaInputRef.current.click()}
                            style={{
                              width: "100%",
                              background: "#f8f8f8",

                              border: "1px solid #c0bcbc",
                              color: "black",
                            }}
                          >
                            {previewAssinatura
                              ? "Substituir Imagem"
                              : "Carregar Imagem"}
                          </button>
                        </div>

                        {/* Configurações */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "15px",
                            flex: 1,
                            minWidth: "220px",
                          }}
                        >
                          {/* Ativar/desativar */}
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={assinatura.ativa}
                              onChange={(e) =>
                                setAssinatura((prev) => ({
                                  ...prev,
                                  ativa: e.target.checked,
                                }))
                              }
                            />
                            <span style={{ fontWeight: "600" }}>
                              Ativar uso da assinatura
                            </span>
                          </label>

                          {assinatura.ativa && (
                            <>
                              <span
                                style={{ fontWeight: "500", color: "#555" }}
                              >
                                Autorizar uso em:
                              </span>
                              {[
                                { key: "orcamentos", label: "Orçamentos" },
                                { key: "prescricoes", label: "Prescrições" },
                                { key: "atestados", label: "Atestados" },
                                { key: "impressos", label: "Impressos" },
                              ].map(({ key, label }) => (
                                <label
                                  key={key}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={assinatura.autorizacoes[key]}
                                    onChange={(e) =>
                                      setAssinatura((prev) => ({
                                        ...prev,
                                        autorizacoes: {
                                          ...prev.autorizacoes,
                                          [key]: e.target.checked,
                                        },
                                      }))
                                    }
                                  />
                                  {label === "Prescrições" ? (
                                    <span style={{ color: "red" }}>
                                      {label}
                                    </span>
                                  ) : (
                                    <span>{label}</span>
                                  )}
                                </label>
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                      <button
                        className="single-user__container__btn"
                        onClick={guardarAssinaturaHandler}
                        style={{ marginTop: "20px" }}
                      >
                        Guardar Assinatura
                      </button>
                    </div>
                  )}

                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Dentista") && (
                    <div className="caixa" style={{ gridColumn: "1 / -1" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <span className="single-user__container__title">
                          Exceções e Bloqueios
                        </span>
                        <span className="single-user__container__subtitle">
                          Configure dias específicos com horários diferentes ou
                          bloqueie datas
                        </span>
                      </div>

                      {excecoes.length > 0 && (
                        <div style={{ marginTop: "20px" }}>
                          {excecoes.map((excecao, index) => (
                            <div
                              key={index}
                              style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                padding: "15px",
                                marginBottom: "15px",
                                backgroundColor: excecao.bloqueado
                                  ? "#FFEBEE"
                                  : "#FFF9C4",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <strong style={{ fontSize: "16px" }}>
                                      {excecao.bloqueado ? "🚫" : "⚠️"}{" "}
                                      {excecao.data.format("DD/MM/YYYY")}
                                    </strong>
                                    {excecao.bloqueado && (
                                      <span
                                        style={{
                                          backgroundColor: "#D32F2F",
                                          color: "white",
                                          padding: "2px 8px",
                                          borderRadius: "4px",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                      >
                                        DIA BLOQUEADO
                                      </span>
                                    )}
                                  </div>
                                  {excecao.motivo && (
                                    <div
                                      style={{
                                        color: "#666",
                                        fontSize: "14px",
                                        marginTop: "5px",
                                      }}
                                    >
                                      Motivo: {excecao.motivo}
                                    </div>
                                  )}
                                  {!excecao.bloqueado && excecao.periodos && (
                                    <div
                                      style={{
                                        color: "#999",
                                        fontSize: "12px",
                                        marginTop: "3px",
                                      }}
                                    >
                                      {excecao.periodos.length} período(s)
                                      disponível(is):{" "}
                                      {excecao.periodos
                                        .map(
                                          (p) =>
                                            `${p.start.format(
                                              "HH:mm",
                                            )} - ${p.end.format("HH:mm")}`,
                                        )
                                        .join(", ")}
                                    </div>
                                  )}
                                </div>
                                <div style={{ display: "flex", gap: "8px" }}>
                                  <button
                                    onClick={() => editarExcecao(index)}
                                    style={{
                                      padding: "6px 12px",
                                      backgroundColor: "#1976D2",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                  >
                                    ✏️ Editar
                                  </button>
                                  <IconButton
                                    color="error"
                                    onClick={() => removerExcecao(index)}
                                    size="small"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {!showExcecaoForm ? (
                        <button
                          className="single-user__container__btn"
                          onClick={() => setShowExcecaoForm(true)}
                          style={{ marginTop: "15px" }}
                        >
                          + Adicionar Exceção/Bloqueio
                        </button>
                      ) : (
                        <div
                          style={{
                            border: "2px solid #1976D2",
                            borderRadius: "8px",
                            padding: "20px",
                            marginTop: "15px",
                            backgroundColor: "#E3F2FD",
                          }}
                        >
                          <div style={{ marginBottom: "15px" }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DesktopDatePicker
                                label="Data"
                                inputFormat="DD-MM-YYYY"
                                value={novaExcecao.data}
                                onChange={(value) =>
                                  setNovaExcecao((prev) => ({
                                    ...prev,
                                    data: value,
                                  }))
                                }
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth />
                                )}
                              />
                            </LocalizationProvider>
                          </div>

                          <div style={{ marginBottom: "15px" }}>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={novaExcecao.bloqueado}
                                onChange={(e) =>
                                  setNovaExcecao((prev) => ({
                                    ...prev,
                                    bloqueado: e.target.checked,
                                    periodos: e.target.checked
                                      ? []
                                      : prev.periodos,
                                  }))
                                }
                              />
                              <span style={{ fontWeight: "500" }}>
                                Bloquear dia inteiro (sem atendimentos)
                              </span>
                            </label>
                          </div>

                          {!novaExcecao.bloqueado && (
                            <div
                              style={{
                                backgroundColor: "white",
                                padding: "15px",
                                borderRadius: "4px",
                                marginBottom: "15px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "10px",
                                }}
                              >
                                <span style={{ fontWeight: "500" }}>
                                  Períodos Disponíveis
                                </span>
                                <IconButton
                                  color="primary"
                                  onClick={() =>
                                    setNovaExcecao((prev) => ({
                                      ...prev,
                                      periodos: [
                                        ...prev.periodos,
                                        {
                                          start: moment()
                                            .startOf("day")
                                            .add(8, "hours"),
                                          end: moment()
                                            .startOf("day")
                                            .add(12, "hours"),
                                        },
                                      ],
                                    }))
                                  }
                                  size="small"
                                >
                                  <AddIcon />
                                </IconButton>
                              </div>

                              {novaExcecao.periodos.map((periodo, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr auto",
                                    gap: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                  >
                                    <DesktopTimePicker
                                      label="Início"
                                      value={periodo.start.toDate()}
                                      onChange={(newValue) => {
                                        const novosPeriodos = [
                                          ...novaExcecao.periodos,
                                        ];
                                        novosPeriodos[index].start =
                                          moment(newValue);
                                        setNovaExcecao((prev) => ({
                                          ...prev,
                                          periodos: novosPeriodos,
                                        }));
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} size="small" />
                                      )}
                                    />
                                  </LocalizationProvider>

                                  <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                  >
                                    <DesktopTimePicker
                                      label="Fim"
                                      value={periodo.end.toDate()}
                                      onChange={(newValue) => {
                                        const novosPeriodos = [
                                          ...novaExcecao.periodos,
                                        ];
                                        novosPeriodos[index].end =
                                          moment(newValue);
                                        setNovaExcecao((prev) => ({
                                          ...prev,
                                          periodos: novosPeriodos,
                                        }));
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} size="small" />
                                      )}
                                    />
                                  </LocalizationProvider>

                                  <IconButton
                                    color="error"
                                    onClick={() => {
                                      setNovaExcecao((prev) => ({
                                        ...prev,
                                        periodos: prev.periodos.filter(
                                          (_, i) => i !== index,
                                        ),
                                      }));
                                    }}
                                    size="small"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              ))}
                            </div>
                          )}

                          <div style={{ marginBottom: "15px" }}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: "5px",
                                fontWeight: "500",
                              }}
                            >
                              Motivo (opcional)
                            </label>
                            <input
                              type="text"
                              placeholder="Ex: Férias, Conferência, Emergência"
                              value={novaExcecao.motivo}
                              onChange={(e) =>
                                setNovaExcecao((prev) => ({
                                  ...prev,
                                  motivo: e.target.value,
                                }))
                              }
                              style={{
                                width: "100%",
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                              }}
                            />
                          </div>

                          <div style={{ display: "flex", gap: "10px" }}>
                            <button
                              className="single-user__container__btn"
                              onClick={adicionarExcecao}
                              style={{ backgroundColor: "#1976D2" }}
                            >
                              Adicionar
                            </button>
                            <button
                              className="single-user__container__btn"
                              onClick={() => {
                                setShowExcecaoForm(false);
                                setNovaExcecao({
                                  data: moment(),
                                  periodos: [],
                                  motivo: "",
                                  bloqueado: false,
                                });
                              }}
                              style={{ backgroundColor: "#757575" }}
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {/* Modal de Edição de Horários do Período Especial */}
      <Dialog
        open={!!editingPeriodoEspecial}
        onClose={fecharEdicaoPeriodoEspecial}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          ⚙️ Configurar Horários - {editingPeriodoEspecial?.nome}
          <div
            style={{
              fontSize: "14px",
              color: "#666",
              marginTop: "5px",
            }}
          >
            {editingPeriodoEspecial?.dataInicio.format("DD/MM/YYYY")} até{" "}
            {editingPeriodoEspecial?.dataFim.format("DD/MM/YYYY")}
          </div>
        </DialogTitle>

        <DialogContent dividers>
          <Tabs
            value={diaSelecionadoPeriodoEspecial}
            onChange={(e, newValue) =>
              setDiaSelecionadoPeriodoEspecial(newValue)
            }
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              mb: 2,
            }}
          >
            {diasSemana.map((dia) => (
              <Tab key={dia.value} label={dia.label} value={dia.value} />
            ))}
          </Tabs>

          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <span style={{ fontWeight: "500" }}>
                Períodos de trabalho -{" "}
                {
                  diasSemana.find(
                    (d) => d.value === diaSelecionadoPeriodoEspecial,
                  )?.label
                }
              </span>
              <IconButton
                color="primary"
                onClick={adicionarPeriodoNoPeriodoEspecial}
                size="small"
              >
                <AddIcon />
              </IconButton>
            </div>

            {!editingPeriodoEspecial?.horarioPadrao[
              diaSelecionadoPeriodoEspecial
            ] ||
            editingPeriodoEspecial?.horarioPadrao[diaSelecionadoPeriodoEspecial]
              .length === 0 ? (
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  color: "#999",
                  border: "1px dashed #ddd",
                  borderRadius: "4px",
                }}
              >
                Sem períodos configurados para este dia. Clique em + para
                adicionar.
              </div>
            ) : (
              editingPeriodoEspecial?.horarioPadrao[
                diaSelecionadoPeriodoEspecial
              ]?.map((periodo, index) => (
                <div
                  key={index}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr auto",
                    gap: "15px",
                    alignItems: "center",
                    padding: "15px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopTimePicker
                      label="Início"
                      value={periodo.start.toDate()}
                      onChange={(newValue) =>
                        atualizarPeriodoNoPeriodoEspecial(
                          diaSelecionadoPeriodoEspecial,
                          index,
                          "start",
                          newValue,
                        )
                      }
                      renderInput={(params) => (
                        <TextField {...params} size="small" />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopTimePicker
                      label="Fim"
                      value={periodo.end.toDate()}
                      onChange={(newValue) =>
                        atualizarPeriodoNoPeriodoEspecial(
                          diaSelecionadoPeriodoEspecial,
                          index,
                          "end",
                          newValue,
                        )
                      }
                      renderInput={(params) => (
                        <TextField {...params} size="small" />
                      )}
                    />
                  </LocalizationProvider>

                  <IconButton
                    color="error"
                    onClick={() =>
                      removerPeriodoNoPeriodoEspecial(
                        diaSelecionadoPeriodoEspecial,
                        index,
                      )
                    }
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))
            )}
          </div>
        </DialogContent>

        <DialogActions>
          <button
            onClick={fecharEdicaoPeriodoEspecial}
            style={{
              padding: "8px 16px",
              backgroundColor: "#757575",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
          <button
            onClick={salvarPeriodoEspecial}
            style={{
              padding: "8px 16px",
              backgroundColor: "#1976D2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Salvar
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SingleUser;
